import styled from 'styled-components';

export const Label = styled.label`
  cursor: pointer;
  user-select: none;
`;

export const Input = styled.input.attrs({
  type: 'checkbox',
})`
  opacity: 0;
  width: 0;
  height: 0;
  display: none;

  &:checked + span {
    background-color: ${props => props.theme.colors.switchActive};
    border: none;

    &:after {
      left: 20px;
      background-color: #fff;
      border: 1px solid #e6e6e6;
    }
  }
`;

export const Lever = styled.span`
  content: "";
  display: inline-block;
  position: relative;
  width: 40px;
  height: 16px;
  background-color: #f3f3f3;
  border-radius: 15px;
  transition: background 0.3s ease;
  vertical-align: middle;
  margin: 0 2px;
  box-sizing: border-box;

  &:after {
    content: "";
    position: absolute;
    display: inline-block;
    width: 21px;
    height: 21px;
    background-color: #e9e9e9;
    border: 1px solid #e2d9d9;
    border-radius: 21px;
    left: -1px;
    top: -3px;
    box-sizing: border-box;
    transition: left 0.3s ease, background 0.3s ease, box-shadow 0.1s ease;
  }
`;
